import HandWritingLink from './hand-writing'

/**
 * 数学入力の directive.link を実現するクラス。
 * HandWritingDirective から派生する。
 * 
 * [依存関係]
 * HandWritingLink
 */
export default class MathHandWritingLink extends HandWritingLink {
  /**
   * createRegistOption上書き
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  createRegistOption(scope, element, attrs, ctrl) {
    const option = super.createRegistOption(scope, element, attrs, ctrl);

    option.recognitionParams = Object.assign(option.recognitionParams || {}, {
      type: 'MATH',
      iink: {
        math: {
          customGrammar : RESOURCES_MATH_NO_ALPHABET[0],
          // customGrammarId : RESOURCES_MATH_NO_ALPHABET[0],//error
          // customGrammarContent: RESOURCES_MATH_NO_ALPHABET[0],
          // mimeTypes: ['application/x-latex', 'application/vnd.myscript.jiix'],// before iinkjs ver 1.5.4
          mimeTypes: ['application/x-latex'],
        },
        export: {
          jiix: {
            // strokes: true,//mathはこれだけ
          }
        },
      }
    });

    return option;
  }

  /**
   * 筆跡データを取得する場合は、筆跡取得のためのマウスイベントをセットする$elementを返す。
   * @returns $element
   */
  getStrokeCaptureElement() {
    return this.element.closest('.recognition-element')
  }
}